import { useOrganization } from '@providers/organization';
import { useGetSubscriptionOverviewQuery } from '../subscription.queries.generated';

export const useSubscriptionData = () => {
    const [organizationId] = useOrganization();

    const { data, loading, error, refetch } = useGetSubscriptionOverviewQuery({
        variables: { id: organizationId },
        skip: !organizationId,
        fetchPolicy: 'cache-and-network',
    });

    return {
        organization: data?.organization,
        loading,
        error,
        refetch,
    };
};
